import { Component } from '@angular/core';
import { FormGroup, FormBuilder, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { WPBService } from 'app/modules/work-planning-budget/services/work-planning-budget.service';
import { Location } from '@angular/common';
import { CorrectiveMaintenanceService } from 'app/modules/corrective-maintenance/services/corrective-maintenance.service';
import module from "app/modules/work-planning-budget/wpb.module";

@Component({
  selector: 'app-wpb-create',
  templateUrl: './wpb-create.page.html',
  standalone: true,
  imports: module,
  styleUrls: ['./wpb-create.page.scss']
})
export class WpbCreatePage {
  public wpbForm: FormGroup
  public initialFormValues: any;
  public wpbRecord: any
  public stringResult: any

  private cmId = this.route.snapshot.paramMap.get('id');
  public isCmIdEmpty = this.cmId === 'null'

  searchForm: UntypedFormGroup;

  ngOnInit() {
    this.wpbForm = this.initializeForm()
    this.setSearch()

    if (!this.isCmIdEmpty) this.getCmDetails()

    this.onChangeStatus()
  }

  constructor(
    private fb: FormBuilder,
    public location: Location,
    private cmServices: CorrectiveMaintenanceService,
    private wpbService: WPBService,
    private route: ActivatedRoute,
    private router: Router,
    private _formBuilder: UntypedFormBuilder
  ) { }


  initializeForm() {
    return this.fb.group({
      // wpbId: null,
      cmId: this.isCmIdEmpty ? null : this.cmId,
      wellStringId: null,
      platformShortName: [{ value: '', disabled: !this.isCmIdEmpty }],
      platformLongName: [{ value: '', disabled: !this.isCmIdEmpty }],
      fieldShortName: [{ value: '', disabled: !this.isCmIdEmpty }],
      fieldLongName: [{ value: '', disabled: !this.isCmIdEmpty }],
      wellShortName: [{ value: '', disabled: !this.isCmIdEmpty }],
      wellLongName: [{ value: '', disabled: !this.isCmIdEmpty }],
      stringShortName: [{ value: '', disabled: !this.isCmIdEmpty }],
      stringLongName: [{ value: '', disabled: !this.isCmIdEmpty }],
      stringIndicatorShortName: "",
      submissionDate: "",
      submissionYear: null,
      submissionType: "",
      integrityIssue: "",
      proposalDesc: "",
      planExecutionDate: "",
      planCostRmMil: null,
      actualCostRmMil: [{ value: null, disabled: true }, Validators.required],
      remark: "",
      wpbStatus: "Open",
      inputBy: "",
      inputDate: "",
      updateBy: [{ value: '', disabled: true }],
      updateDate: [{ value: new Date().toISOString(), disabled: true }],
    })
  }

  setSearch() {
    this.searchForm = this._formBuilder.group({
      WellName: [''],
      PlatformName: [''],
      StringName: [''],
      FieldName: [''],
    });
  }

    private onChangeStatus() {
      this.wpbForm.get('wpbStatus').valueChanges.subscribe((res) => {
        const actualCost = this.wpbForm.get('actualCostRmMil');
  
        if (res === 'Closed') {
          actualCost.enable();
          actualCost.setValidators([Validators.required]);
        } else {
          actualCost.disable();
          actualCost.setValue(null)
          actualCost.clearValidators();
        }
  
        actualCost.updateValueAndValidity();
      })
    }

  onSelectedString($event) {
    let wellString = $event
    this.wpbForm.patchValue({
      wellStringId: wellString.id
    })
  }

  getCmDetails() {
    this.cmServices.getCMRecord(this.cmId).subscribe((res) => {
      this.wpbForm.patchValue({
        // wpbId: '',
        cmId: this.cmId,
        wellStringId: res.data.wellStringId,
        stringShortName: res.data.wellShortName,
        wellLongName: res.data.wellLongName,
        fieldLongName: res.data.fieldLongName,
        fieldShortName: res.data.fieldLongName,
        platformLongName: res.data.platformLongName,
        platformShortName: res.data.platformShortName,
      })

      this.initialFormValues = { ...this.wpbForm.getRawValue() }
    })
  }

  createWpb() {
    this.wpbService.createUpdateWpb(this.wpbForm.getRawValue())
      .subscribe((res) => {
        if (res) {
          this.location.back()
        }
      })
  }

  // Method to check if the form values have changed
  hasFormChanged(): boolean {
    return JSON.stringify(this.initialFormValues) !== JSON.stringify(this.wpbForm.getRawValue());
  }

  handleDate(date) {
    return handleFormatDate(date, true)
  }

  wpbPage() {
    this.router.navigate([`/data-management/work-planning-budget`]);
  }

  disabledCreate(): boolean {
    return this.wpbForm.get('wellStringId').value == null ||  !this.hasFormChanged() || !this.wpbForm.valid 
  }
}
